export const SEND_WELCOME_EMAIL_OPEN_MODAL = "SEND_WELCOME_EMAIL_OPEN_MODAL";
export const SEND_WELCOME_EMAIL_CLOSE_MODAL = "SEND_WELCOME_EMAIL_CLOSE_MODAL";

export const SEND_WELCOME_EMAIL_REQUEST = "SEND_WELCOME_EMAIL_REQUEST";
export const SEND_WELCOME_EMAIL_RESULT = "SEND_WELCOME_EMAIL_RESULT";